import {forwardRef} from "react";
import styles from "./PremiumButton.module.css";

/**
 * @param {"primary" | "secondary" | "ghost" | "danger"} variant
 * @param {"sm" | "md" | "lg"} size
 */
const PremiumButton = forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "md",
      fullWidth = false,
      disabled = false,
      isLoading = false,
      type = "button",
      className = "",
      onClick,
      ariaLabel,
      ...rest
    },
    ref
  ) => {
    const classNames = [styles.btn, styles[variant], styles[size], fullWidth ? styles.fullWidth : "", className]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type={type}
        className={classNames}
        onClick={onClick}
        disabled={disabled || isLoading}
        aria-label={ariaLabel}
        aria-busy={isLoading || undefined}
        {...rest}
      >
        {isLoading && <span className={styles.spinner} />}
        {children}
      </button>
    );
  }
);

PremiumButton.displayName = "PremiumButton";

export default PremiumButton;
